module.exports = __webpack_public_path__ + "0fcfb37d3af8d833024623df77ccc445.pdf";